import "./App.css";
import { GlobalContextProvider } from "./context/store";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import DefaultHome from "./screens/DefaultHome";
import Login from "./screens/login/Login";
import DashboardHome from "./screens/dashboard/DashboardHome";

// syncfusion
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-documenteditor/styles/material.css";
import "@syncfusion/ej2-filemanager/styles/material.css";
import "@syncfusion/ej2-grids/styles/material.css";
import "@syncfusion/ej2-lists/styles/material.css";
import "@syncfusion/ej2-material-theme/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
// import "@syncfusion/ej2-react-base/styles/material.css";
import "@syncfusion/ej2-react-base";
import "@syncfusion/ej2-react-filemanager/styles/material.css";
import "@syncfusion/ej2-react-grids/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";
import { registerLicense } from "@syncfusion/ej2-base";

// toast
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./ErrorBoundary";

function App() {
  // Registering Syncfusion license key
  registerLicense(
    "Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXhecnRSR2BfV0RyW0o="
  );

  return (
    <ErrorBoundary>
      <GlobalContextProvider>
        <Router>
          <Routes>
            <Route path="/" element={<DefaultHome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<DashboardHome />} />
          </Routes>
        </Router>

        <ToastContainer
          position={"top-right"}
          autoClose={7000}
          hideProgressBar={false}
          closeOnClick={true}
          pauseOnHover={true}
          draggable={true}
          theme={"dark"}
          transition={Bounce}
        />
      </GlobalContextProvider>
    </ErrorBoundary>
  );
}

export default App;
